import { useStudentDunningDialog } from "../../hooks/useStudentDunningDialog";
import Board from "../../misc/Board";
import { DunningColumnFooter } from "./DunningColumnFooter";
import { DunningCard } from "./DunningCard";
import { DunningStudentDialog } from "../../dialogs/DunningStudentDialog/DunningStudentDialog";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { DunningStudent } from "./DunningDashboard";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";

interface DunningColumnProps {
  title: string;
  students: DunningStudent[];
  drivingSchoolsById: Record<string, DrivingSchool>;
  isLoading: boolean;
  amount?: number;
  actions?: React.ReactNode[];
}

export const DunningColumn = ({
  students,
  drivingSchoolsById,
  isLoading,
  amount,
  title,
  actions,
}: DunningColumnProps) => {
  const { dialogProps, openDialog } = useStudentDunningDialog();

  return (
    <>
      <Board.Column
        title={title}
        footer={amount !== undefined ? <DunningColumnFooter amount={amount} title={title} /> : undefined}
      >
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <>
            {students.map((student) => (
              <DunningCard
                key={student.id}
                student={student}
                drivingSchool={drivingSchoolsById[student.drivingSchoolId]}
                onClick={(student) => openDialog(student.id)}
              />
            ))}
          </>
        )}
      </Board.Column>
      <DunningStudentDialog actions={actions ?? []} {...dialogProps} />
    </>
  );
};
